// ===== Overlay Registry (열린 오버레이 공통 신호) =====
// v1: popstate로 뷰가 전환될 때 열린 모달이 새 뷰 위에 고아로 남지 않도록,
// 전역 popstate 핸들러(router.ts)가 뷰 전환 전에 이 레지스트리를 통해 열린 오버레이를
// 모두 닫는다. v2(뒤로가기로 모달 개별 닫기 — 히스토리 항목 승격)는 범위 밖 — 여기는
// "전부 닫기"만 지원한다.
// 등록 상태는 body 클래스 overlay-open으로도 노출한다(공통 신호 겸용, 스타일 정의는 없음).

interface OverlayRegistryContract {
  register(id: string, closeFn: () => void): void;
  unregister(id: string): void;
  hasOpen(): boolean;
  closeAll(): void;
}

const OverlayRegistry: OverlayRegistryContract = (() => {
  const overlays = new Map<string, () => void>();

  function _syncBodyClass(): void {
    if (typeof document === "undefined" || !document.body) return;
    document.body.classList.toggle("overlay-open", overlays.size > 0);
  }

  function register(id: string, closeFn: () => void): void {
    overlays.set(id, closeFn);
    _syncBodyClass();
  }

  function unregister(id: string): void {
    overlays.delete(id);
    _syncBodyClass();
  }

  function hasOpen(): boolean {
    return overlays.size > 0;
  }

  // registry를 먼저 비운 뒤 각 closeFn을 try/catch로 호출한다 — 하나가 throw해도
  // 나머지 오버레이는 계속 닫힌다(closeFn 내부의 unregister 재호출은 무해한 no-op).
  function closeAll(): void {
    const closeFns = Array.from(overlays.values());
    overlays.clear();
    for (const closeFn of closeFns) {
      try {
        closeFn();
      } catch (err) {
        console.error("[overlay-registry] closeFn error:", err);
      }
    }
    _syncBodyClass();
  }

  return { register, unregister, hasOpen, closeAll };
})();
